/**
 * Shared link-to-page-type conversion for website preview and champs home preview.
 * Used by website-preview-page and home-page-preview to avoid duplicate logic.
 */

/** Map a page name (e.g. from pages[].name) to a page type slug. */
export function pageNameToPageType(pageName: string): string {
  const n = (pageName || '').toLowerCase().trim();
  if (n === 'home') return 'home';
  if (n.includes('express wash') || n.includes('express_wash')) return 'express-wash-packages';
  if (n.includes('express detail') || n.includes('express_detail') || n.includes('express auto')) return 'express-auto-details';
  if (n.includes('fleet')) return 'fleet-management';
  if (n.includes('coupon')) return 'coupons';
  return 'home';
}

/**
 * Convert a button/link (e.g. "/express-washes", "express-washes") to a page type.
 * Uses pages array to resolve by name/path when link does not match a known slug.
 */
export function convertLinkToPageType(
  link: string | undefined,
  pages: any[],
  getPageType: (pageName: string) => string = pageNameToPageType
): string {
  if (!link) return 'home';
  const normalizedLink = link.replace(/^\/+|\/+$/g, '').toLowerCase();
  if (!normalizedLink || normalizedLink === 'home' || normalizedLink === '') return 'home';
  if (normalizedLink.includes('express-wash') || normalizedLink === 'express-washes') return 'express-wash-packages';
  if (normalizedLink.includes('express-detail') || normalizedLink.includes('express-auto') || normalizedLink === 'express-details') return 'express-auto-details';
  if (normalizedLink.includes('fleet')) return 'fleet-management';
  if (normalizedLink.includes('coupon')) return 'coupons';

  const matchingPage = pages?.find((p: any) => {
    const pageName = (p.name || '').toLowerCase();
    const pagePath = (p.path || '').replace(/^\/+|\/+$/g, '').toLowerCase();
    return pageName === normalizedLink || pagePath === normalizedLink;
  });
  if (matchingPage) return getPageType(matchingPage.name);
  return 'home';
}
